import axios from 'axios';
// 1. Detect environment
// If the browser URL contains "localhost" or "127.0.0.1", we are Local.
const isLocal = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

// 2. Choose the Backend URL
const backendUrl = isLocal 
  ? 'http://127.0.0.1:8000/api/'  // PC Python Port
  : 'https://siteact-c9bectckf9csh5fn.westeurope-01.azurewebsites.net/api/'; // Azure
// 1. Create the Axios Instance
const api = axios.create({
  baseURL: backendUrl, // Make sure this matches your Django URL
});

// 2. Add the "Request Interceptor"
// This runs BEFORE every request is sent
api.interceptors.request.use(
  (config) => {
    // Check if we have a token in local storage
    const token = localStorage.getItem('access_token');
    
    // If we do, attach it to the header: "Authorization: Bearer <token>"
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 3. (Optional) Add a "Response Interceptor" to handle expired tokens
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        // If the server says "401 Unauthorized" (Token invalid/expired)
        if (error.response && error.response.status === 401) {
            console.log("Token expired or invalid. Logging out...");
            localStorage.clear();
            window.location.href = '/'; // Force redirect to login
        }
        return Promise.reject(error);
    }
);

export default api;